/**
 * Pluggable access-token provider for FCM operations.
 * The hub sets this during bootstrap so embedded sub-apps can call
 * fcmToken.register() using the hub's bearer token.
 */

type AccessTokenProvider = () => string | null;

let provider: AccessTokenProvider | null = null;

export function setFcmAccessTokenProvider(fn: AccessTokenProvider): void {
	provider = fn;
}

export function getFcmAccessToken(): string | null {
	return provider?.() ?? null;
}
